// @ts-nocheck
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '../redux/reducers';
import rootSaga from '../redux/sagas';

const sagaMiddleware = createSagaMiddleware();

export default function configureStore() {
  const middlewares = [sagaMiddleware];

  const store = createStore(reducers, compose(applyMiddleware(...middlewares)));

  sagaMiddleware.run(rootSaga);
  store.runSaga = sagaMiddleware.run;

  return store;
}
